import React, { useEffect, useRef } from 'react'
import { RenderDropdown } from './dropdown';
import swal from 'sweetalert';


export const CustomRenderBox = ({
    tableBoxes,
    settableBoxes,
    areaProps,
    fieldsExtracted,
    tablesExtracted,
    PageNo,
    refList,
    Lables,
    setLables,
    setchangeDetect
}) => {


    const lableEl = useRef(null)

    function DeletePop(areaNum) {
        swal('Are you sure you want to Delete?', {
            buttons: ['No', 'Yes'],
        }).then((value) => {
            if (value) {
                // User clicked "Yes" button
                let deleteIndex = areaNum - 1;

                let allTags = [...tableBoxes[PageNo]];
                if (deleteIndex !== -1) {
                    //   let flds = { ...fieldsExtracted }
                    //   delete flds[allTags[deleteIndex]['entity']]
                    allTags.splice(deleteIndex, 1);
                    //   setfieldsExtracted(flds)
                    
                    settableBoxes(p => {
                        let tp = {...p}
                        tp[PageNo] = allTags
                        return tp 
                    });
                    setchangeDetect(true)
                }

            }
        });
    }

    useEffect(() => {
        function handleClass() {
            refList.current.map(itm => {
                itm.current.classList.remove("clicked")
                itm.current.style.zIndex = 2 
                return null
            }
            )
            lableEl.current.classList.add("clicked")
            lableEl.current.style.zIndex = 3
        }

        if (lableEl.current) {
            refList.current.push(lableEl)
            var node = lableEl.current.parentNode
            node.addEventListener('click', handleClass);
        }
    let observerRefValue = refList?.current
    
      return () => {
        if (observerRefValue) {
            observerRefValue.splice(observerRefValue.indexOf(lableEl))
            node?.removeEventListener('click', handleClass);
        }
           
      }
    }, [])
    

    return (
        <div ref={lableEl} className="areaBoxOuter" key={areaProps.areaNumber}>
            <button
                type="button"
                className="delBBBtn"
                onClick={() => DeletePop(areaProps.areaNumber)}
            >
                &times;
            </button>
            <RenderDropdown
                    tableBoxes={tableBoxes}
                    settableBoxes={settableBoxes}
                    areaProps={areaProps}
                    fieldsExtracted={fieldsExtracted}
                    tablesExtracted={tablesExtracted}
                    PageNo={PageNo}
                    Lables={Lables}
                    setchangeDetect={setchangeDetect}
                />
            
        </div>
    )
}